import Calendar from '@/pages/Calendar';
import ProtectedRoute from '@/components/auth/ProtectedRoute';

export default function CalendarPage() {
  return (
    <ProtectedRoute>
      <Calendar />
    </ProtectedRoute>
  );
}
